import React from 'react'
import { Translation } from 'react-i18next'

export const AMAZON_SELLER_ACCOUNT_MODALS = {
  accountDetails: 'accountDetails',
  deleteAccount: 'deleteAccount',
  disablePPC: 'disablePPC'
}

export const AMAZON_SELLER_KEYS_SYNC_STEPS = {
  tutorialModal: 'tutorialModal',
  accountSync: 'accountSync',
  setupLoading: 'setupLoading',
  setupError: 'setupError',
  accountSetup: 'accountSetup'
}

export const PPC_SYNC_STATUS = {
  initial: 'initial',
  success: 'success',
  failure: 'failure'
}

export const MWS_SYNC_STATUS = {
  initial: 'initial',
  success: 'success',
  failure: 'failure'
}

export const LOCAL_STORAGE_KEYS = {
  MWS_SYNC_REDIRECT_STATE: 'MWS_SYNC_REDIRECT_STATE',
  PPC_SYNC_REDIRECT_STATE: 'PPC_SYNC_REDIRECT_STATE'
}

export const USD_CURRENCY_CODE = 'usd'
export const EUR_CURRENCY_CODE = 'eur'
export const INR_CURRENCY_CODE = 'inr'
export const JPY_CURRENCY_CODE = 'jpy'

export const CN_CHECKOUT_LOCALE = 'CN'

export const CHINESE_LANGUAGE_CHECKOUT_LOCALES = [
  CN_CHECKOUT_LOCALE,
  'TW',
  'MO',
  'HK'
]

export const USD_PRICING_PAGE_URL = 'https://www.junglescout.com/pricing'
export const USD_TEST_PRICING_PAGE_URL = 'https://www.junglescout.com/pricing'
export const CN_PRICING_PAGE_URL =
  'https://www.junglescout.cn/upgrade-plan-page'
export const DE_EUR_PRICING_PAGE_URL = 'https://www.junglescout.com/de/pricing'
export const ES_EUR_PRICING_PAGE_URL = 'https://www.junglescout.com/es/pricing'
export const FR_EUR_PRICING_PAGE_URL = 'https://www.junglescout.com/fr/pricing'
export const IT_EUR_PRICING_PAGE_URL = 'https://www.junglescout.com/it/pricing'
export const INR_PRICING_PAGE_URL = 'https://www.junglescout.com/in/pricing'
export const JPY_PRICING_PAGE_URL = 'https://www.junglescout.com/jp/pricing'

export const ACCOUNT_ADD_USER_MODAL = 'AccountAddUserModal'
export const NOTIFY_EXPIRING_CARD_MODAL = 'NotifyExpiringCardModal'
export const EXPIRING_CARD_LAST_NOTIFIED = 'expiringCardLastNotified'
export const NO_PLAN_MODAL = 'NoPlanModal'

export const INVALID_EMAIL_MESSAGE = (
  <Translation ns="sessions">
    {t =>
      t(
        'sessions:LoginForm.email.invalidEmailMessage',
        'Please enter a valid email format.'
      )
    }
  </Translation>
)

export const ACCOUNT_SETTINGS_ICONS = {
  account: 'USER',
  billing: 'CREDIT_CARD',
  subscriptions: 'LAYERS',
  email: 'MAIL',
  amazon: 'AMAZON_CIRCLE',
  team: 'USERS',
  languages: 'TRANSLATE'
}
